import { Exception } from '@src/types';

export class InvalidMetricsException extends Exception {}
